import React from 'react';
import { IFeaturedColumns } from '../../types';
import PriceRowStoreInfoColumn from '../shared/store-info-column';
import * as S from '../styles';
// import AlternativesIndicator from './alternatives-indicator';
import StockPriceInfo from '../../components/stock-price-info';
// import { StoreRatingAverage } from '../../components/store-rating-average';
import Clickable from '@prisjakt/ui-clickable';
// import StoreTags from '../../components/store-tags';
// import PaymentProviders from '../../components/payment-provider';
import { GoToStoreButton } from '../../components/go-to-store-button';
import { getContainerProps } from '../../utils';

export const FeaturedColumns: React.FC<IFeaturedColumns> = props => {
  const {
    tableLinkProps,
    // alternativePrices,
    campaign,
    priceDisplay,
    name,
    price,
    priceType,
    stock,
    store,
    rating,
    isInternationalPrice,
    deliveryOptions,
    brandRecommendedRetailer,
    isMemberPrice,
    shipping,
    deliveryTimeExperimentVal,
  } = props;

  const containerProps = getContainerProps(
    name || '',
    Boolean(store?.featured),
    tableLinkProps.onClick,
    tableLinkProps.href
  );
  // const storeIndicatorsExist = hasStoreIndicators(
  //   store,
  //   isInternationalPrice,
  //   market,
  //   deliveryOptions,
  //   brandRecommendedRetailer
  // );

  return (
    <S.ActionArea container={Clickable} containerProps={containerProps}>
      <S.Content>
        <PriceRowStoreInfoColumn store={store} rating={rating} />
        <S.MiddleColumn featured>
          <S.TopMiddleRow>
            <S.ProductNameColumn featured>
              <S.ProductName featured>{name}</S.ProductName>
            </S.ProductNameColumn>
            <StockPriceInfo
              featured
              campaign={campaign}
              price={price}
              priceDisplay={priceDisplay}
              priceType={priceType}
              stock={stock}
              isMemberPrice={isMemberPrice}
              countryCode={store && store.countryCode}
              isInternationalPrice={isInternationalPrice}
              shipping={shipping}
              deliveryOptions={deliveryOptions}
              brandRecommendedRetailer={brandRecommendedRetailer}
            />
          </S.TopMiddleRow>
          {/* <S.BottomMiddleRow featured hasStoreIndicators={hasStoreIndicators}>
            <S.Column>
              <S.MobileOnly>
                <S.StoreInfoMobileView>
                  <PriceRowStoreInfoColumn
                    store={store}
                    rating={rating}
                    smallLogo
                  />
                  <StoreRatingAverage
                    store={store}
                    rating={rating}
                    showReviewCount={false}
                  />
                </S.StoreInfoMobileView>
              </S.MobileOnly>
              {store && (
                <>
                  <S.DesktopAndMedium>
                    <S.PaymentProvidersColumn>
                      <PaymentProviders store={store} limit={4} />
                    </S.PaymentProvidersColumn>
                  </S.DesktopAndMedium>
                  <S.MobileOnly>
                    <S.PaymentProvidersColumn>
                      <PaymentProviders store={store} limit={1} />
                    </S.PaymentProvidersColumn>
                  </S.MobileOnly>
                </>
              )}
            </S.Column>
            <S.Column>
              <StoreTags
                countryCode={store && store.countryCode}
                isInternationalPrice={isInternationalPrice}
                deliveryOptions={deliveryOptions}
                brandRecommendedRetailer={brandRecommendedRetailer}
              />
            </S.Column>
          </S.BottomMiddleRow> */}
        </S.MiddleColumn>
        <S.EndColumn featured>
          <GoToStoreButton
            deliveryTimeExperimentVal={deliveryTimeExperimentVal}
          />
        </S.EndColumn>
      </S.Content>
    </S.ActionArea>
  );
};
